export const isAscii = (text: string): boolean => Array.from(text).every((char) => char.charCodeAt(0) < 128)
